




























import Vue from 'vue'
import imgResize from '~/utils/img-zip'
export default Vue.extend({
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    pureWhiteBackground: Boolean,
    show: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    text: String,
    transition: {
      type: String,
      default: 'du-loading-mask'
    }
  },
  watch: {
    show(val) {
      this.$emit('update:show', val)
    }
  },
  methods: {
    imgResize
  }
})
